import React from 'react';
import { ArrowUpRight } from 'lucide-react';

const cols = [
  { title: 'Index', links: [
    { label: 'Intro', href: '#home' },
    { label: 'Capabilities', href: '#services' },
    { label: 'Studio', href: '#about' },
    { label: 'Process', href: '#process' },
    { label: 'Stack', href: '#technologies' },
    { label: 'Contact', href: '#contact' },
  ]},
  { title: 'Capabilities', links: [
    { label: 'AI Software', href: '#services' },
    { label: 'Gaming Systems', href: '#services' },
    { label: 'iGaming', href: '#services' },
    { label: 'Payments', href: '#services' },
    { label: 'Marketing AI', href: '#services' },
  ]},
  { title: 'Elsewhere', links: [
    { label: 'Twitter / X', href: '#' },
    { label: 'GitHub', href: '#' },
    { label: 'LinkedIn', href: '#' },
    { label: 'Dribbble', href: '#' },
  ]},
];

const Footer = () => {
  return (
    <footer className="relative border-t border-white/5 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-24 pb-14">
        {/* CTA block */}
        <div className="grid md:grid-cols-12 gap-10 pb-20 border-b border-white/10">
          <div className="md:col-span-8">
            <div className="text-[10px] uppercase tracking-[0.3em] text-white/40">End credits</div>
            <h3 className="mt-4 font-light text-[40px] md:text-[72px] lg:text-[96px] leading-[0.95] tracking-[-0.03em] chromatic-text">
              The next scene<br />starts with you.
            </h3>
          </div>
          <div className="md:col-span-4 flex md:justify-end items-end">
            <a href="#contact" data-cursor="hover"
               className="group inline-flex items-center gap-4 border border-white/15 hover:border-cyan-400/50 rounded-full pl-6 pr-2 py-2 transition-colors duration-500">
              <span className="text-[12px] uppercase tracking-[0.3em] text-white">Start a project</span>
              <span className="w-12 h-12 rounded-full bg-white text-black flex items-center justify-center group-hover:bg-cyan-300 transition-colors duration-500">
                <ArrowUpRight className="w-5 h-5 transition-transform duration-500 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </span>
            </a>
          </div>
        </div>

        {/* Columns */}
        <div className="grid grid-cols-2 md:grid-cols-12 gap-10 mt-14">
          <div className="md:col-span-4 col-span-2">
            <div className="flex items-center gap-3">
              <div className="w-2 h-2 rounded-full bg-cyan-400 animate-pulseGlow" />
              <span className="text-sm tracking-[0.3em] uppercase font-medium text-white/90">OZZLABS</span>
            </div>
            <p className="mt-5 text-sm text-white/50 leading-relaxed max-w-sm">
              A quiet studio engineering AI, gaming and payment systems for teams who refuse to ship the ordinary.
            </p>
            <div className="mt-6 text-[10px] uppercase tracking-[0.3em] text-white/35 font-mono">
              Istanbul · Remote · Global
            </div>
          </div>

          {cols.map((c) => (
            <div key={c.title} className="md:col-span-2">
              <h5 className="text-[10px] font-medium text-white/40 tracking-[0.3em] uppercase">{c.title}</h5>
              <ul className="mt-5 space-y-3">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} data-cursor="hover" className="group flex items-center gap-1 text-sm text-white/65 hover:text-white transition-colors">
                      {l.label}
                      <ArrowUpRight className="w-3 h-3 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Giant watermark */}
        <div className="mt-20 overflow-hidden">
          <div className="font-light text-[22vw] leading-[0.85] tracking-[-0.06em] chromatic-text whitespace-nowrap select-none opacity-70">
            OZZLABS
          </div>
        </div>

        <div className="mt-6 pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-3 text-[10px] uppercase tracking-[0.3em] text-white/35 font-mono">
          <span>© {new Date().getFullYear()} Ozzlabs · All rights reserved</span>
          <span>v2.0 · Scene 06 / 06 · End of reel</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
